import {getIdToken} from './CognitoService';

const API_BASE_URL = process.env.REACT_APP_CALENDAR_CHECKER_ENDPOINT_URL!;

/**
 * Verifies a Google Calendar ID by calling the protected API Gateway endpoint
 * using Cognito User Pool JWT authorizer.
 * @param calendarId The calendar ID to check.
 * @returns true if the calendar exists, false otherwise.
 */
export async function verifyCalendar(calendarId: string): Promise<boolean> {
  // Fetch the current user's Cognito ID token
  const idToken = await getIdToken();

  // Call the API with Authorization header
  const response = await fetch(
    `${API_BASE_URL}/calendar-exists?calendarId=${encodeURIComponent(calendarId)}`,
    {
      method: 'GET',
      headers: {
        'Authorization': idToken,
        'Content-Type': 'application/json'
      },
    }
  );

  if (!response.ok) {
    throw new Error(`API request failed: ${response.status} ${response.statusText}`);
  }

  const data = await response.json();
  return data.exists as boolean;
}